import * as React from 'react';
import Expand, { Props as ExpandProps } from '../Expand/Expand';
import { SidebarMenuContext } from './SidebarMenuContext';

const { useContext, useEffect } = React;

export interface Props extends Omit<ExpandProps, 'expanded'> {}

/**
 * Child of the SidebarMenu component that is used to insert an
 * expandable submenu that is visible when the parent SidebarMenu
 * component is active.
 */
const SidebarSubMenu: React.FunctionComponent<Props> = (props: Props) => {
  const { children, ...rest } = props;
  const { active, setHasSubMenu } = useContext(SidebarMenuContext);

  useEffect(() => {
    setHasSubMenu(true);

    return () => {
      setHasSubMenu(false);
    };
  }, []);

  return (
    <Expand { ...rest } className="Sidebar__sub-menu" expanded={ active }>
      { children }
    </Expand>
  );
};

export default SidebarSubMenu;
